import React from 'react';
import { MailIcon, MapPinIcon, MessageCircleIcon, PhoneIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { contact } from '../data/contact';
const channels = [{
  icon: MessageCircleIcon,
  label: 'WhatsApp',
  value: contact.whatsapp,
  href: contact.whatsappHref
}, {
  icon: PhoneIcon,
  label: 'Llamada',
  value: contact.phone,
  href: contact.phoneHref
}, {
  icon: MailIcon,
  label: 'Email',
  value: contact.email,
  href: contact.emailHref
}, {
  icon: MapPinIcon,
  label: 'Dirección',
  value: contact.address,
  href: contact.addressHref
}];
export function Contact() {
  return <section id="contacto" aria-labelledby="contacto-title" className="relative border-t border-silver/10 bg-night py-20 sm:py-28" data-id="element-3" data-mp="3f6kyj0o4lnf0">
      <div className="mx-auto w-full max-w-5xl px-5 sm:px-8" data-id="element-4" data-mp="ghnjpsjfqph2">
        <SectionHeading id="contacto-title" eyebrow="Estamos disponibles" title="CONTACTO" data-id="element-5" data-mp="bpcimmcykxmx" />

        <ul className="mt-14 grid gap-4 sm:grid-cols-2" data-id="element-6" data-mp="3jw4is1tzln0h">
          {channels.map(({
          icon: Icon,
          label,
          value,
          href
        }) => <li key={label} data-id="element-7" data-mp="3owif4mm878io">
              <a href={href} className="flex h-full items-start gap-5 rounded-2xl border border-silver/15 bg-carbon/70 p-6 transition-colors hover:border-accent-soft/40 hover:bg-carbon focus:outline-none focus-visible:ring-2 focus-visible:ring-accent-soft sm:p-7" {...label === 'WhatsApp' || label === 'Dirección' ? {
            target: '_blank',
            rel: 'noreferrer'
          } : {}} data-id="element-8" data-mp="3b3svupy30hp9">
                <span className="mt-0.5 flex h-10 w-10 shrink-0 items-center justify-center rounded-full border border-silver/20 bg-violet-dark/50" data-id="element-9" data-mp="2s6rmksxhvvfi">
                  <Icon className="h-4 w-4 text-accent-soft" aria-hidden="true" data-id="element-10" data-mp="qe3fg8hqcnug" />
                </span>
                <span className="min-w-0" data-id="element-11" data-mp="udm156hdl2yc">
                  <span className="block text-[0.68rem] font-medium uppercase tracking-[0.24em] text-silver/70" data-id="element-12" data-mp="ucay58vr7z8a">
                    {label}
                  </span>
                  <span className="mt-2 block break-words font-display text-lg font-light tracking-[0.03em] text-frost" data-id="element-13" data-mp="1ybpm2if38fkw">
                    {value}
                  </span>
                </span>
              </a>
            </li>)}
        </ul>
      </div>
    </section>;
}